<template>
  <div>
    <b-form-group v-if="hasAnyImage">
      <b-button
        class="w-100 mt-2"
        @click="translateImage"
      >
        Translate Image
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID,
  BACKGROUND_THEME_IMAGE_PREFIX_ID,
  UPLOAD_IMAGE_PREFIX_ID,
  IMAGE_FROM_BK_PREFIX_ID,
} from '@frontend/constants/templates-field-prefixes';
import {
  translateTemplateImageEventBroker,
  EVENTS,
} from '@frontend/group/modules/translate-template-image/event-broker';

const IMG_PREFIXES = [
  BACKGROUND_THEME_IMAGE_PREFIX_ID,
  ADDITIONAL_BACKGROUND_THEME_IMAGE_PREFIX_ID,
  UPLOAD_IMAGE_PREFIX_ID,
  IMAGE_FROM_BK_PREFIX_ID,
];

export default {
  name: 'TranslateImageButton',

  props: {
    targetLanguages: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters('layout', [
      'selectedInstance',
    ]),
    hasAnyImage() {
      if (!this.selectedInstance || !this.selectedInstance.canvas) {
        return false;
      }

      const objects = this.selectedInstance.canvas.getObjects() || [];

      return objects.some(obj => {
        if (obj.type === 'image') return true;

        if (typeof obj.id === 'string') {
          return IMG_PREFIXES.some(prefix => obj.id.startsWith(prefix));
        }

        return false;
      });
    },
  },

  methods: {
    translateImage() {
      if (!this.selectedInstance) return;

      const objects = Array.isArray(this.selectedInstance.canvas?.getObjects())
        ? this.selectedInstance.canvas.getObjects()
        : [];

      translateTemplateImageEventBroker.fire(
        EVENTS.INIT,
        {
          fields: this.selectedInstance.fields || [],
          preview: this.selectedInstance,
          objects,
          targetLanguages: this.targetLanguages,
          translateSection: 1
        }
      );

      this.$nextTick(() => {
        const el = document.querySelector(
          `.translate-image[data-id="${this.selectedInstance.id}"]`
        );

        if (el) {
          el.click();
        }
      });
    },
  },
}
</script>
